import { render, staticRenderFns } from "./DownloadWindowsSync.vue?vue&type=template&id=113570a6&scoped=true"
import script from "./DownloadWindowsSync.vue?vue&type=script&lang=js"
export * from "./DownloadWindowsSync.vue?vue&type=script&lang=js"
import style0 from "./DownloadWindowsSync.vue?vue&type=style&index=0&id=113570a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113570a6",
  null
  
)

export default component.exports